import logger from 'ws-scripts/modules/logger';

export function formatCurrencyUSD(num, showFractionDigits = false) {
	// supports USD currency formats until business need support for other
	// const formattedLocale = locale.replace('_', '-');

	const options = {
		style: 'currency',
		currency: 'USD'
	};

	let currencyValue;
	if (typeof num !== 'number') {
		logger.warn(
			`formatCurrencyUSD: unexpected currency value: ${num} of type ${typeof num}`
		);
		return '';
	}

	if (showFractionDigits) {
		// two fraction digits by default
		currencyValue = num;
	} else {
		currencyValue = Math.round(num);
		options.minimumFractionDigits = 0;
	}

	return new Intl.NumberFormat('en-US', options).format(currencyValue);
}

export function numberWithCommas(x) {
	return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
}

export function stripCommas(x) {
	return x.toString().replace(/,/g, '');
}
